import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get values() {
    return { prompts: Array, index: { type: Number, default: 0 } }
  }

  static get targets() {
    return ["input"]
  }

  remix() {
    this.inputTarget.value = this.promptsValue[this.indexValue]
    this.inputTarget.style.height = "auto"
    this.inputTarget.style.height = this.inputTarget.scrollHeight + "px"
    this.indexValue = (this.indexValue + 1) % this.promptsValue.length
  }
}
